<template>
  <div
    ref="table"
    class="features-table"
  >
    <div
      class="big-back-text-table"
      :class="{
        'big-back-text-smaller': $route.query.gm_type === 'straddle_ante_cash',
      }"
    >
      <div class="big-back-text-table_content">
        {{ $route.query.gm_type ? $t(`gametypes.groups.${$route.query.gm_type}`) : '' }}
      </div>
    </div>

    <transition
      name="slidetop"
      mode="in-out"
    >
      <div
        v-if="showBar"
        class="all-features-bar"
      >
        <div class="all-features-bar_inner">
          <slot />
        </div>
      </div>
    </transition>

    <div class="features-table-head">
      <div
        class="features-table-title cl-wide"
        style="z-index: 2"
      >
        {{ $t('table_features.all_features') }}
      </div>
      <div
        v-if="!gmStraddle"
        class="cl-normal f-center"
        style="z-index: 2"
      >
        {{ $t('subscription.free.title') }}
      </div>
      <div
        v-if="!gmStraddle"
        class="cl-normal f-center"
        style="z-index: 2"
      >
        {{ $t('subscription.starter.title') }}
      </div>
      <div
        class="cl-normal f-center"
        style="z-index: 2"
      >
        {{ $t('subscription.premium.title') }}
      </div>
      <div
        class="cl-normal f-center"
        style="z-index: 2"
      >
        {{ $t('subscription.elite.title') }}
      </div>
    </div>

    <div
      v-for="(section, sIdx) in sections"
      :key="`${sIdx}_${section.title}`"
      class="features-table-section"
    >
      <div
        class="features-table-row section-title"
        :class="{ 'title-first': sIdx === 0 }"
      >
        <div class="features-table-subtitle cl-wide f-align-center">
          <i
            class="mr-3 mdi text-big"
            :style="section.icon_style"
            :class="[section.icon, section.icon_class]"
          >
          </i>
          {{ section.title }}
        </div>
      </div>

      <div
        v-for="(feature, fIdx) in section.features"
        :key="`${fIdx}_${feature.name}-${section.title}`"
        class="features-table-row"
      >
        <div class="cl-wide">
          <component
            :is="feature.tooltip ? 'TooltipUnderline' : 'span'"
            v-bind="
              feature.tooltip
                ? {
                    img: feature.tooltip.img,
                    text: feature.tooltip.text,
                  }
                : {}
            "
          >
            <a
              v-if="feature.link"
              :href="feature.link"
              target="_blank"
              class="link-underline clr-primary mr-1"
              v-html="feature.link_name"
            >
            </a>
            <span v-if="feature.name">
              {{ feature.name }}
            </span>
            <br v-if="feature.subtitle" />
            <span
              v-if="feature.subtitle"
              class="text-small"
            >
              {{ feature.subtitle }}
            </span>
            <span
              v-if="feature.hasTagSoon"
              class="position-relative"
            >
              <span
                v-if="feature.tagText"
                class="tag-soon"
              >
                {{ feature.tagText }}
              </span>
              <span
                v-else
                class="tag-soon"
              >
                {{ $t('common.soon') }}
              </span>
            </span>
          </component>
        </div>
        <div
          v-for="(option, oIdx) in feature.options"
          :key="`${oIdx}_${section.title}`"
          class="cl-normal f-center"
          :class="{ 'option-disabled': option.disabled }"
        >
          <span
            v-if="option.disabled"
            class="disabled-icon"
          ></span>
          <v-icon
            v-if="option.icon"
            color="primary"
            >{{ option.icon }}</v-icon
          >
          <span v-if="option.text">
            {{ option.text }}
            <span v-if="option.asterisk">*</span>
          </span>

          <TooltipUnderline
            v-if="option.tooltip"
            v-bind="option.tooltip"
            :cssClass="option.tooltip.css_class"
          >
            <i
              v-if="option.tooltip.icon"
              class="mdi clr-grey position-absolute"
              style="top: -0.5rem; font-size: 18px; height: 1.5rem; line-height: 1"
              :class="option.tooltip.icon"
            ></i>
            <!-- <span :class="option.tooltip.hover_text_css_class || 'text-grey'">
              {{ option.tooltip.hover_text }}
            </span> -->
            <span class="posiiton-relative">
              <!-- <i
                class="mdi mdi-asterisk clr-yellow"
                v-if="option.tooltip.hasAsterisk"
              ></i> -->
              {{ option.tooltip.hover_text }}

              <!-- <i
                class="mdi mdi-asterisk clr-yellow"
                v-if="option.tooltip.hasAsterisk"
              ></i> -->

              <span
                v-if="option.tooltip.info"
                class="tag-soon"
                style="left: calc(100% + 6px)"
              >
                More info
              </span>
            </span>
          </TooltipUnderline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipUnderline from '@/components/Payments/TooltipUnderline'
import payment_mix from '@/mixins/payment_mix'
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'AllFeaturesTable',
  components: {
    TooltipUnderline,
  },
  mixins: [payment_mix, format_mix, links_mix],
  data() {
    return {
      showBar: false,
    }
  },
  methods: {
    handleScroll() {
      const { table } = this.$refs
      if (table) {
        const { y, height } = table.getBoundingClientRect()
        const res = y <= -64 && height + y > 220
        this.showBar = res
      } else {
        this.showBar = false
      }
    },
  },
  computed: {
    sections() {
      const gm_type = this.gm_type || 'cash'

      const solutionsSection = {
        title: this.$t('links.study_solutions'),
        icon: 'mdi-table-search',
        icon_style: 'color:#b100ff',
      }
      const preflopSolutions = {
        name: this.$t('table_features.study.preflop_solutions'),
        options: [
          { text: this.$t('common.basic') },
          { text: this.$t('common.basic') },
          { icon: 'mdi-check' },
        ],
        tooltip: {
          text: this.$t('table_features.study.preflop_solutions_tooltip'),
          img: 'features/1.webp',
        },
      }
      const aiSolving = {
        name: this.$t('table_features.ai_solving_all'),
        options: [{ disabled: true }, { disabled: true }, { disabled: true }],
        tooltip: {
          text: this.$t('table_features.ai_solving_tooltip', {
            ...(!this.$i18n.g1
              ? {
                  link: this.$t('common.link_text', {
                    url: 'https://blog.gtowizard.com/introducing-gto-wizard-ai/',
                    text: this.$t('common.read_more'),
                    cssClass: 'text-underline_hover hover_lighted',
                  }),
                }
              : {}),
          }),
        },
      }
      const nodelocking = {
        name: this.$t('table_features.nodelocking'),
        options: [{ disabled: true }, { disabled: true }, { disabled: true }],
        tooltip: {
          text: this.$t('table_features.nodelocking_tooltip'),
        },
      }
      const aiEvSolving = {
        name: this.$t('table_features.dynamic_ev_sizings'),
        options: [{ disabled: true }, { disabled: true }, { disabled: true }],
        tooltip: {
          text: this.$t('table_features.dynamic_ev_sizings_tooltip'),
        },
      }

      const customRakeSolving = {
        name: this.$t('subscription.starter.custom_rake_solving'),
        options: [{ disabled: true }, { disabled: true }, { disabled: true }],
        tooltip: {
          text: this.$t('subscription.starter.custom_rake_solving_tooltip'),
        },
      }

      const customIcmSolving = {
        name: this.$t('subscription.elite.custom_solving_with_icm'),
        options: [{ disabled: true }, { disabled: true }, { disabled: true }],
      }

      const cash = {
        ...solutionsSection,
        features: [
          aiSolving,

          aiEvSolving,
          preflopSolutions,
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.cash_6max')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.depth_xxx_only', {
                    available_depths: '100BB',
                  }),
                  text: this.$t('table_features.study.depths_xxx_only_tooltip', {
                    tier: this.$t('tier.options.starter'),
                    available_depths: '100BB',
                  }),
                },
              },
              {
                tooltip: {
                  hover_text: this.$t('table_features.study.all_depths_xxx', {
                    available_depths: '20-200BB',
                  }),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: this.$t('tier.options.premium'),
                    available_depths: '20,40,50,75,100,150,200BB',
                  }),
                },
              },
            ],
          },

          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.cash_9max')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.depth_xxx_only', {
                    available_depths: '100BB',
                  }),
                  text: this.$t('table_features.study.depths_xxx_only_tooltip', {
                    tier: this.$t('tier.options.starter'),
                    available_depths: '100BB',
                  }),
                },
              },
              { text: '100 BB' },
            ],
          },

          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.headsup')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.depth_xxx_only', {
                    available_depths: '100BB',
                  }),
                  text: this.$t('table_features.study.depths_xxx_only_tooltip', {
                    tier: this.$t('tier.options.starter'),
                    available_depths: '100BB',
                  }),
                },
              },
              {
                tooltip: {
                  hover_text: this.$t('table_features.study.all_depths_xxx', {
                    available_depths: '20-500BB',
                  }),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: this.$t('tier.options.starter'),
                    available_depths: '20, 40, 60, 80, 100, 150, 200, 300, 400, 500BB',
                  }),
                },
              },
            ],
          },

          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.straddle_ante_cash_6max')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },

            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.depth_xxx_only', {
                    available_depths: '100BB',
                  }),
                  text: this.$t('table_features.study.depths_xxx_only_tooltip', {
                    tier: this.$t('tier.options.starter'),
                    available_depths: '100BB',
                  }),
                },
              },
              {
                tooltip: {
                  hover_text: this.$t('table_features.study.all_depths_xxx', {
                    available_depths: '50-400BB',
                  }),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: this.$t('tier.options.premium'),
                    available_depths: '50, 75, 100, 150, 200, 300, 400BB',
                  }),
                },
              },
            ],
          },

          customRakeSolving,
        ],
      }
      const straddle_ante_cash = {
        ...solutionsSection,
        features: [
          aiSolving,

          aiEvSolving,
          {
            name: this.$t('table_features.study.preflop_solutions'),
            tooltip: {
              text: this.$t('table_features.study.preflop_solutions_tooltip'),
              img: 'features/1.webp',
            },
            options: [{ disabled: true }, { disabled: true }, { icon: 'mdi-check' }],
          },
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.straddle_ante_cash_6max')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              { disabled: true },
              { disabled: true },
              {
                text: '50, 75, 100, 150, 200, 300, 400BB',
                // tooltip: {
                // hover_text: this.$t('table_features.study.all_depths_xxx', { available_depths: '50-100BB' }),
                // text: this.$t('table_features.study.all_depths_tooltip', {
                //   tier: this.$t('tier.options.premium'),
                //   available_depths: '50, 75, 100BB',
                // }),
                // },
              },
            ],
          },
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.tiers.straddle_ante_cash_8max')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              { disabled: true },
              { disabled: true },
              { text: '100, 150, 200BB' },
              // {
              //   tooltip: {
              //     hover_text: '100, 150, 200BB',
              //     info: true,
              //     // hover_text: this.$t('table_features.study.all_depths', { available_depths: '100-200BB' }),
              //     text: 'All spots are available for all depths, except all postflop spots including a small blind. We are still solving these spots, and we will add them soon.',
              //   },
              // },
            ],
          },

          customRakeSolving,
        ],
      }
      const mtt = {
        ...solutionsSection,
        features: [
          aiSolving,

          aiEvSolving,
          preflopSolutions,
          {
            name: this.$t('table_features.study.preflop_solutions_mixed_stacks'),
            // subtitle: this.$t('table_features.study.x_depths', { num: 13 }),
            tooltip: {
              text: this.$t('table_features.study.preflop_solutions_mixed_stacks_tooltip'),
            },
            options: [
              { disabled: true },
              { disabled: true },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_xxx_situations', { num: '1500+' }),
                  text: this.$t('table_features.study.preflop_solutions_mixed_stacks_tooltip'),
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.postflop_solutions'),
            // subtitle: this.$t('table_features.study.x_depths', { num: 13 }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.x_depths_only', {
                    available_depths: 5,
                  }),
                  text: '14, 25, 35, 60, 80 BB',
                },
              },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: '6max + 8max',
                  // hover_text: this.$t('table_features.study.all_xxx_depths', { num: 21 }),
                  text: '6max and 8max symmetric and mixed stack sizes.',
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.headsup_solutions'),
            options: [
              { disabled: true },
              { disabled: true },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_xxx_depths', { num: 37 }),
                  text: '1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 16, 18, 20, 25, 30, 40, 50, 60 BB',
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.icm_solutions'),
            options: [
              { disabled: true },
              { disabled: true },
              {
                tooltip: {
                  hover_text: this.$t('table_features.study.all_xxx_situations', { num: '9000+' }),
                  text: this.$t('tooltips.mtt_icm_solutions'),
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.icm_pko_solutions'),
            options: [
              { disabled: true },
              { disabled: true },
              {
                // text: this.$t('table_features.study.all_xxx_situations', { num: 83 }),

                tooltip: {
                  hover_text: this.$t('table_features.study.all_xxx_situations', { num: '1500+' }),
                  text: this.$t('tooltips.mtt_icm_pko_solutions', { num: '1500+' }),
                },
              },
            ],
          },
          customIcmSolving,
          {
            name: this.$t('table_features.study.icm_events'),
            tooltip: {
              text: this.$t('table_features.study.icm_events_tooltip'),
              img: 'features/icm_events.webp',
            },
            options: [
              { disabled: true },
              { disabled: true },
              { icon: 'mdi-check' },
              { icon: 'mdi-check' },
            ],
          },
        ],
      }
      const spins = {
        ...solutionsSection,
        features: [
          aiSolving,

          aiEvSolving,
          preflopSolutions,
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.groups.husng')}`,
            }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.x_depths_only', {
                    available_depths: 13,
                  }),
                  text: '25, 20, 18, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB',
                },
              },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_depths'),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: `${this.$t('gametypes.groups.husng')}`,
                    available_depths_total: 30,
                    available_depths:
                      '25, 22.5, 20, 18, 16, 15, 14.5, 14, 13.5, 13, 12.5, 12, 11.5, 11, 10.5, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1 BB',
                  }),
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.groups.spins')}`,
            }),
            // subtitle: this.$t('table_features.study.x_depths', { num: 28 }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                tooltip: {
                  hover_text: this.$t('gametypes.SYMMETRIC'),
                  // hover_text: this.$t('table_features.study.x_depths_only', { available_depths: 13 }),
                  text: `
                  ${this.$t(`tooltips.what_are_symmetric_stacks`)}
                  `,
                },
              },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_depths'),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: `${this.$t('gametypes.groups.spins')}`,
                    available_depths_total: 28,
                    available_depths:
                      '35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 16, 15, 14, 13, 12, 11, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1',
                  }),
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.postflop_solutions_variable', {
              solution_type: `${this.$t('gametypes.groups.spins_ante')}`,
            }),
            // subtitle: this.$t('table_features.study.x_depths', { num: 28 }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                tooltip: {
                  hover_text: this.$t('gametypes.SYMMETRIC'),
                  // hover_text: this.$t('table_features.study.x_depths_only', { available_depths: 13 }),
                  text: `${this.$t(`tooltips.what_are_symmetric_stacks`)} <br> (Ante is 0.17bb)`,
                },
              },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_depths'),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: `${this.$t('gametypes.groups.spins')}`,
                    available_depths_total: 28,
                    available_depths:
                      '24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1. (Ante is 0.17bb)',
                  }),
                },
              },
            ],
          },
          {
            name: this.$t('table_features.study.posflop_solutions_mixed_stacks_simple', {
              solution_type: `${this.$t('gametypes.groups.spins')}`,
            }),
            options: [
              { disabled: true },
              { disabled: true },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_varying_stacks', { num: '600+' }),
                  text: this.$t('tooltips.what_is_varying_stacks_solutions'),
                  // img: 'features/bigger/varying_stacks.webp',
                },
              },
            ],
          },
        ],
      }
      const husng = {
        ...solutionsSection,
        features: [
          aiSolving,

          aiEvSolving,
          preflopSolutions,
          {
            name: this.$t('table_features.study.postflop_solutions'),
            // subtitle: this.$t('table_features.study.x_depths', { num: 30 }),
            tooltip: {
              text: this.$t('table_features.study.postflop_solutions_tooltip'),
              img: 'features/2.webp',
            },
            options: [
              {
                text: this.$t('table_features.study.solution_per_day', {
                  free_solution_per_day: 1,
                }),
              },
              {
                id: 'starter_depth_option',
                tooltip: {
                  hover_text: this.$t('table_features.study.x_depths_only', {
                    available_depths: 13,
                  }),
                  text: '25, 20, 18, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB',
                },
              },
              {
                tooltip: {
                  hover_text_css_class: 'cl-primary',
                  hover_text: this.$t('table_features.study.all_xxx_depths', { num: 48 }),
                  text: this.$t('table_features.study.all_depths_tooltip', {
                    tier: `${this.$t('gametypes.groups.husng')}`,
                    available_depths_total: 30,
                    available_depths:
                      '1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13.5, 14.5, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 35, 40, 45, 50, 55, 60, 72 BB',
                  }),
                },
              },
            ],
          },
        ],
      }

      function getTooltipHtml(items) {
        return items.map(i => `<div>${i}</div>`).join(' ')
      }

      const flop_reports = {
        cash: getTooltipHtml([
          'BTN v BB, SRP, 100bb',
          'UTG v BB, SRP, 100bb',
          'BTN v SB, 3bet, 100bb',
        ]),
        mtt: getTooltipHtml([
          'HJ vs BTN, 3bet, 60bb',
          'SB v BB, limp, 14bb',
          'CO vs BTN, SRP, 35bb',
        ]),
        spins: getTooltipHtml([
          'BTN v BB, SRP, 25bb',
          'SB v BB, limp, 15bb',
          'SB v BB HU, iso, 25bb',
        ]),
        husng: getTooltipHtml(['SB v BB, 3bet, 25bb', 'SB v BB, SRP, 18bb', 'SB v BB, limp, 20bb']),
      }

      const turn_reports = {
        cash: 'BTN v BB, SRP, 100bb',
        mtt: 'SB v BB, limp, 14bb',
        spins: 'BTN v BB, SRP, 25bb',
        husng: 'SB v BB, 3bet, 25bb',
      }

      let res = [
        gm_type === 'cash' ? cash : null,
        gm_type === 'mtt' ? mtt : null,
        gm_type === 'spins' ? spins : null,
        gm_type === 'husng' ? husng : null,
        gm_type === 'straddle_ante_cash' ? straddle_ante_cash : null,
        {
          title: this.$t('table_features.study.title'),
          icon: 'mdi-school',
          icon_class: 'clr-primary',
          features: [
            {
              name: this.$t('table_features.study.ranges_comparisons'),
              tooltip: {
                text: this.$t('table_features.study.ranges_comparisons_tooltip'),
                img: 'features/5.webp',
              },
              options: [
                {
                  text: this.$t('table_features.study.solution_per_day', {
                    free_solution_per_day: 1,
                  }),
                },
                { icon: 'mdi-check' },
                { icon: 'mdi-check' },
              ],
            },
            nodelocking,
            {
              name: this.$t('table_features.study.copy_ranges'),
              tooltip: {
                text: this.$t('table_features.study.copy_ranges_tooltip'),
                img: 'features/11.webp',
              },
              options: [{ disabled: true }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
            // {
            //   hasTagSoon: true,
            //   name: this.$t('table_features.study.GTO_lessons'),
            //   tooltip: {
            //     text: this.$t('table_features.study.GTO_lessons_tooltip', { gto_lessons_num: 13 }),
            //   },
            //   options: [
            //     { icon: 'mdi-check' },
            //     { icon: 'mdi-check' },
            //     { icon: 'mdi-check' },
            //   ],
            // },
            {
              // available_for_types: ['cash'],
              name: this.$t('table_features.study.weekly_coachings'),
              tooltip: {
                text: this.$t('table_features.study.weekly_coachings_tooltip'),
                img: 'features/coaching.webp',
              },
              options: [{ disabled: true }, { disabled: true }, { icon: 'mdi-check' }],
            },
            {
              // hasTagSoon: true,
              name: this.$t('table_features.study.blockers_score'),
              tooltip: {
                text: this.$t('table_features.study.blockers_score_tooltip'),
              },
              options: [{ disabled: true }, { disabled: true }, { icon: 'mdi-check' }],
            },
            {
              // hasTagSoon: true,
              // hasTagSoon: gm_type === 'straddle_ante_cash',
              // tagText: `after ${this.formatISODate('2022-02-09T00:00Z')}`,
              name: this.$t('table_features.study.aggregated_reports'),
              tooltip: {
                text: this.$t('table_features.study.aggregated_reports_tooltip'),
              },
              options: [
                { disabled: true },
                {
                  tooltip: {
                    hover_text: this.$t('table_features.study.basic_flop', { basic_flop_num: 3 }),
                    // text: this.$t('table_features.study.basic_flop_tooltip', { basic_flop_num: 3 }),
                    // text: this.$t('table_features.study.aggregated_reports_tooltip'),
                    text: flop_reports[gm_type],
                  },
                },
                { icon: 'mdi-check' },
              ],
            },
            {
              // hasTagSoon: true,
              name: this.$t('table_features.study.turns_ev_aggregation'),
              tooltip: {
                text: this.$t('table_features.study.turns_ev_aggregation_tooltip'),
              },
              options: [
                { disabled: true },
                {
                  tooltip: {
                    hover_text: this.$t('table_features.study.basic_turn', { basic_turn_num: 1 }),
                    text: turn_reports[gm_type],
                    // text: this.$t('table_features.study.basic_turn_tooltip', { basic_turn_num: 1 }),
                  },
                },
                { icon: 'mdi-check' },
              ],
            },
            {
              // hasTagSoon: true,
              name: this.$t('table_features.study.study_plans'),
              tooltip: {
                text: this.$t('table_features.study.study_plans_tooltip'),
              },
              options: [{ disabled: true }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
          ],
        },

        {
          title: this.$t('table_features.practice.title'),
          icon_class: 'clr-practice',
          icon: 'mdi-google-controller',
          features: [
            // {
            //   name: this.$t('table_features.practice.spec_spot_training'),
            //   tooltip: {
            //     text: this.$t('table_features.practice.spec_spot_training_tooltip'),
            //     img: 'features/6.webp',
            //   },
            //   options: [
            //     { text: this.$t('table_features.practice.hands_10_day', { hands_10_day_num: 10 }) },
            //     {
            //       copy_content_id: 'starter_depth_option',
            //       // icon: 'mdi-check'
            //     },
            //     { icon: 'mdi-check' },
            //   ],
            // },
            {
              name: this.$t('table_features.practice.full_hand_playthrough_v1'),
              tooltip: {
                text: this.$t('table_features.practice.full_hand_playthrough_tooltip'),
                img: 'features/3.webp',
              },
              options: [
                { text: this.$t('table_features.practice.hands_10_day', { hands_10_day_num: 10 }) },
                {
                  copy_content_id: 'starter_depth_option',
                  // icon: 'mdi-check'
                },
                { icon: 'mdi-check' },
              ],
            },

            {
              name: this.$t('table_features.practice.range_construction'),
              tooltip: {
                text: this.$t('table_features.practice.range_construction_tooltip'),
              },
              options: [
                { text: this.$t('table_features.practice.spot_per_day', { spot_per_day_num: 1 }) },
                { icon: 'mdi-check' },
                { icon: 'mdi-check' },
              ],
            },

            {
              hasTagSoon: true,
              name: this.$t('table_features.practice.puzzles_'),
              tooltip: {
                text: this.$t('table_features.practice.puzzles__tooltip'),
              },
              options: [{ disabled: true }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
            {
              hasTagSoon: true,
              name: this.$t('table_features.practice.stats_reports'),
              tooltip: {
                text: this.$t('table_features.practice.stats_reports_tooltip'),
              },
              options: [{ disabled: true }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
          ],
        },

        {
          title: this.$t('table_features.analyze.title'),
          icon_class: 'clr-analyze',
          icon: 'mdi-lightbulb-on',
          features: [
            {
              name: this.$t('table_features.analyze.hand_histories'),
              tooltip: {
                text: this.$t('table_features.analyze.hand_histories_tooltip'),
                img: 'features/4.webp',
              },
              options: [
                { text: this.$t('table_features.practice.hands_5_mo', { hands_5_mo_num: 5 }) },
                { text: this.$t('table_features.practice.hands_50_mo', { hands_50_mo_num: 50 }) },
                {
                  text: this.$t('table_features.practice.hands_max_mo', {
                    hands_max_mo_num: (100000).toLocaleString(this.$i18n.locale),
                  }),
                },
                {
                  id: '_150khands',
                  text: this.$t('table_features.practice.hands_max_mo', {
                    hands_max_mo_num: (150000).toLocaleString(this.$i18n.locale),
                  }),
                },
              ],
            },
            {
              hasTagSoon: true,
              name: this.$t('table_features.analyze.advanced_GTO_reports'),
              tooltip: {
                text: this.$t('table_features.analyze.advanced_GTO_reports_tooltip'),
              },
              options: [
                { disabled: true },
                { disabled: true },
                { disabled: true },
                // { icon: 'mdi-check' },
                // { icon: 'mdi-check' },
              ],
            },
            {
              hasTagSoon: true,
              name: this.$t('table_features.analyze.GTO_reports'),
              tooltip: {
                text: this.$t('table_features.analyze.GTO_reports_tooltip'),
              },
              options: [
                { disabled: true },
                { disabled: true },
                // { icon: 'mdi-check' },
                { icon: 'mdi-check' },
              ],
            },
            {
              hasTagSoon: true,
              name: this.$t('table_features.analyze.leak_finder'),
              tooltip: {
                text: this.$t('table_features.analyze.leak_finder_tooltip'),
              },
              options: [{ disabled: true }, { disabled: true }, { icon: 'mdi-check' }],
            },
          ],
        },

        {
          title: this.$t('table_features.extra.title'),
          icon_class: 'clr-error',
          icon: 'mdi-star-circle',
          features: [
            {
              name: this.$t('table_features.extra.customer_support'),
              tooltip: {
                text: this.$t('table_features.extra.customer_support_tooltip'),
              },
              options: [{ icon: 'mdi-check' }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
            {
              name: this.$t('table_features.extra.mobile_friendly'),
              tooltip: {
                text: this.$t('table_features.extra.mobile_friendly_tooltip'),
                img: 'features/7.webp',
              },
              options: [{ icon: 'mdi-check' }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
            {
              link: this.links_url_links.discord_invite_link.url,
              link_name: 'Discord',
              name: this.$t('table_features.extra.discord_premium'),
              tooltip: {
                text: this.$t('table_features.extra.discord_premium_tooltip'),
                img: 'features/8.webp',
              },
              options: [{ disabled: true }, { icon: 'mdi-check' }, { icon: 'mdi-check' }],
            },
          ],
        },
      ]

      res = res.filter(i => i)
      res = res.map(i => {
        const aaa = i.features.filter(x => x).find(f => f.available_for_types)
        if (aaa) {
          const features = i.features
            .filter(x => x)
            .filter(f => (f.available_for_types ? f.available_for_types.includes(gm_type) : true))
          return {
            ...i,
            features,
          }
        }

        let pasteFeatureParent = null
        let copyFeatureOption = null
        // debugger
        let copyFeatureParent = res.find(ii =>
          ii.features
            .filter(x => x)
            .find(f => f.options.find(ss => ss.id === 'starter_depth_option')),
        )
        if (copyFeatureParent) {
          copyFeatureParent = copyFeatureParent.features
            .filter(x => x)
            .find(f => f.options.find(ss => ss.id === 'starter_depth_option'))
          copyFeatureOption = copyFeatureParent.options.find(ss => ss.id === 'starter_depth_option')

          // console.log(duplicateFeatureParent)
          // console.log(copyFeatureOption)

          pasteFeatureParent = i.features
            .filter(x => x)
            .find(f => f.options.find(ss => ss.copy_content_id === 'starter_depth_option'))
        }
        if (pasteFeatureParent) {
          const features = i.features
            .filter(x => x)
            .map(f => {
              const options = f.options.map(o => {
                if (o.copy_content_id === 'starter_depth_option') {
                  return copyFeatureOption
                }
                return o
              })
              const r = {
                ...f,
                options,
              }
              return r
            })
          return {
            ...i,
            features,
          }
        }
        // console.log(pasteFeatureParent, i.features)
        return i
      })

      // elite for all
      res = res.map(i => ({
        ...i,
        features: i.features
          .filter(x => x) // feature-flag
          .map(ff => ({
            ...ff,
            options: [
              ...ff.options,
              // ...ff.options.length === 3 ? [{ icon: 'mdi-check' }] : [],
              ...(ff.options.length === 3
                ? [ff.options[2].disabled ? { icon: 'mdi-check' } : ff.options[2]]
                : []),
            ],
          })),
      }))

      if (this.gmStraddle) {
        res = res.map(i => {
          const features = i.features
            .filter(x => x)
            .map(ff => ({
              ...ff,
              options: [
                // { disabled: true },
                // { disabled: true },
                // ff.options[2],
                ff.options[2],
                // { icon: 'mdi-check' },

                ...(ff.options.length === 4
                  ? [
                      ff.options[2].disabled
                        ? { icon: 'mdi-check' }
                        : ff.options[3].id === '_150khands'
                          ? ff.options[3]
                          : ff.options[2],
                    ]
                  : []),
              ],
            }))
          return {
            ...i,
            features,
          }
        })
      }
      // console.log(res)
      // console.log(JSON.stringify(res))
      return res
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
}
</script>

<style lang="scss" scoped>
.big-back-text-smaller {
  font-size: 11rem !important;
  left: -16rem !important;
}
.big-back-text-table {
  position: absolute;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 20rem;
  font-weight: 700;
  top: 3rem;
  left: -26rem;
  text-transform: uppercase;
  color: rgb(255, 255, 255, 0.1);
  transition: 0.3s;
  white-space: nowrap;
  &_content {
    position: sticky;
    top: 0;
  }
}

.all-features-bar {
  position: fixed;
  top: 0;
  left: -2px;
  width: 100vw;
  z-index: 1;
  display: flex;
  &_inner {
    margin: auto;
    // width: 1090px;
    width: 83.5rem;
  }
}

.tag-soon {
  white-space: nowrap;
  position: absolute;
  line-height: 0.7rem;
  padding: 0.0125rem 0.25rem;
  font-size: 0.6rem;
  background: var(--clr-grey-2);
  border-radius: 4px;
  color: black;
  text-transform: uppercase;
  left: 4px;
  bottom: 0.25rem;
}

@media (max-width: 1023px) {
  .cl-wide {
    width: 7.5rem !important;
  }
  .features-table {
    padding: 0 !important;
    background-color: transparent !important;
    position: relative;

    &:before {
      content: '';
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      width: calc(100% + 2rem);
      left: -1rem;
      position: absolute;
    }
  }
  .features-table-head {
    padding: 0.5rem 0 !important;
    position: sticky;
    top: 0;
    z-index: 1;
    border-bottom: none !important;
    z-index: 2;
    &:before {
      content: '';
      height: 100%;
      background: var(--clr-black-0);
      width: calc(100% + 2rem);
      left: -1rem;
      top: 0;
      position: absolute;
      border-bottom: 1px solid var(--clr-black-3);
      z-index: 1;
    }
  }
  .features-table-row {
    padding: 0.5rem 1rem !important;
    width: 100vw;
    position: relative;
    left: -1rem;
  }
  .title-first {
    &:before {
      display: none;
    }
  }
}

.features-table {
  position: relative;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 1rem 0 1rem 0;
  font-weight: 500;
  border-radius: 4px;
}
.features-table-title {
  font-size: 1.25rem;
  font-weight: 700;
  // background-color: rgba(0, 0, 0, 0.3);
}
.features-table-subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  // background-color: rgba(0, 0, 0, 0.3);
}
.features-table-head {
  // background-color: rgba(0, 0, 0, 0.3);

  display: flex;
  padding: 0.5rem 0 0.5rem 2.5rem;
  border-bottom: solid var(--clr-black-3) 1px;
}
.option-disabled {
  color: red;
  .disabled-icon {
    background: var(--clr-grey-2);
    height: 2px;
    width: 1rem;
    border-radius: 4px;
  }
}
.features-table-section {
  border-bottom: solid var(--clr-black-3) 1px;

  &:last-child {
    border: none;
  }
  margin-top: 1rem;
  padding-bottom: 1rem;
  .features-table-row {
    display: flex;
    align-items: center;
    padding: 0.5rem 0 0.5rem 2.5rem;
    // background-color: rgba(0, 0, 0, 0.3);

    // border-radius: 4px;
  }
}
@media (hover: hover) and (pointer: fine) {
  .features-table-section {
    .features-table-row {
      &:not(.section-title):hover {
        // background: var(--clr-grey-2);
        // background: rgba(0, 0, 0, 0.33);
        background: rgb(255, 255, 255, 0.1);
      }
    }
  }
}
.cl-wide {
  width: 17.5rem;
}
.cl-normal {
  text-align: center;
  flex: 1;
  // &:nth-child(2) {
  //   margin: 0 0.5rem;
  // }
}
</style>
